import { render } from "./TheBankAccountList.vue?vue&type=template&id=3d7bdad6&scoped=true&ts=true"
import script from "./TheBankAccountList.vue?vue&type=script&lang=ts"
export * from "./TheBankAccountList.vue?vue&type=script&lang=ts"

import "./TheBankAccountList.vue?vue&type=style&index=0&id=3d7bdad6&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3d7bdad6"]])

export default __exports__